import React from 'react';
import './browse_send_message.less';
import LoggedinFooter from '../footer/loggedin_footer';
import InputComponent from '../components/input_component/input_component';
import {Link, browserHistory} from 'react-router';
import ShipmentDetailsSection from './shipment_details_section';
import MediaQuery from 'react-responsive';
import {commonFunctions} from './browser_common';
import CONSTANTS from '../common_constants';

import ShowError from '../components/error/show_error';
import validate from '../util/validate';
import {join} from '../util/common';

import browsePackagesAction from './browser_packages_actions';
import {routerActions} from 'react-router-redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';

class SendMessage extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      offerData : this.props.browsePackages.offerData,
      error: ''
    }
  }

  getInputValue = (inputName, value) => {

    let offerData = Object.assign({}, this.state.offerData);
    if(value.length >= CONSTANTS.SEND_MESSAGE_TEXT_LIMIT){
      offerData[inputName] = this.state.offerData[inputName];
      this.setState({offerData});
      return;
    }
    offerData[inputName] = value;
    this.setState({
      offerData
    });

  }

  sendmessage = () => {
    let shipmentId = commonFunctions.getShipmentId(this.props.location);

    let validationErrorMsg = '';

    const validationError = {
        message: !validate.name(this.state.offerData.message)
    };
    const validationMap = {
        message: 'Message'
    };
    const validationFields = [];

    Object.keys(validationError).forEach((key) => {
        if (validationError[key]) {
            validationFields.push(validationMap[key]);
        }
    });

    if (validationFields.length) {
        validationErrorMsg = 'Please enter the ' + join(validationFields, (item, idx) => {
            if (validationFields.length === 1)
                return "";
            if (idx > 0 && idx < validationFields.length - 1)
                return ", ";
            else if (idx === validationFields.length - 1)
                return " and ";
            return "";
        }) + '.';
    }

    if (validationErrorMsg) {
        this.setState({error: validationErrorMsg});
        return;
    }

    this.props.browsePackagesAction.makeOffer(this.state.offerData);
    browserHistory.push('/browse-shipments/select-delivery-type/' + shipmentId);
  }

  componentWillReceiveProps(newProps){
    this.setState({
      offerData: newProps.browsePackages.offerData
    })
  }


  render(){
    const self = this;
    const {props, state} = this;
    let shipperName = this.state.offerData.shipperName;
    let shipmentId = commonFunctions.getShipmentId(this.props.location);
    let url = "/shipment/"+ shipmentId + "?backTo=" + 'browse';
    commonFunctions.validateOfferData(props.browsePackages ,props.location);

    return(
      <div>
        <div id="browseSendMessage" className="wrapper">
          <Link to={url}>
            <div className="back-section"><span className="icon-icn_back"></span><span className="back-content">Back</span></div>
          </Link>
          <div className="browse-send-message-wrap">
            <MediaQuery query='(min-width: 768px)'>
              <div className="shipment-details">
                <ShipmentDetailsSection shipmentId ={shipmentId} />
              </div>
            </MediaQuery>
            <div className="send-message">
              {this.state.error && <ShowError errorMessage = {this.state.error} />}
              <div id="sendMessageHeader">Send a Message</div>
              <div id="sendMessageDescription">Send a friendly message to help ensure that {shipperName} confirms your trip.</div>
              <InputComponent value = {this.state.offerData.message} type={'text'} title={'Your Message'} placeholder={'Write your message here'} changeHandler = {this.getInputValue} dollar={false} for='message' />
              <button className="btn orange" onClick={this.sendmessage} id="sendMessageButton">Next</button>
            </div>
          </div>
        </div>
        <LoggedinFooter />
      </div>
    )
  }
}

SendMessage = connect((state) => {
  return {
    authState: state.app.auth,
    browsePackages: state.app.browsePackages,
    shipment: state.app.shipment
  }
}, (dispatch) => {
  return {
    browsePackagesAction: bindActionCreators(browsePackagesAction, dispatch)
  }
})(SendMessage);

export default SendMessage;



// WEBPACK FOOTER //
// app/browse_packages/browse_send_message.jsx